/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */
/* eslint-disable no-unused-expressions */
import { getThrottleKeys } from '../Helpers/taggingHelper';
// import { postMessage } from '../Helpers/app';
import {
  getUrlName,
  getCookie,
  getSession,
  isJointTransactionFlow,
  isMoversFlow,
  isShippingTabEnabled,
  getPlanSelectionJourney,
  getPageName,
  setSession,
  removeSessionItem,
  isExpressCheckout,
  isDesktopResolution,
  isECJointTransactionFlow,
  getSoThrottleValue,
  isDeviceUpgradeFlow,
  isExpressCheckoutNSE,
  isWWM,
  getAdditionalDiscountTaggingFFlag,
  isLTE,
  isStreamlineFlow,
  getTechRecommendationLQResponse, 
  saveTheSaleTaggingFFlag,
  isCbandStalledFlow,
  isEnableMiniCartTaggingFFlag,
  enableNgdJTCartFFlag,
  isJTFlowFromNGDCart,
  isTRUPFlow,
  isTrupUpgradeFlow,
} from '../Helpers';
import logger from '../ErrorBoundary/logger_new';
import * as constants from './constants';
import { store } from '../../../configureStore';
import { ADOBE_OVERRIDES, CLEAR_ADOBE_QUEUE } from '../../../pages/Common/Tagging.js/Constants';
import { showContinueCTAInFooter } from '../../NextGen/ProgressivePlans/common';
import { FE_JS_ERROR, logError } from '../../../services/loggerService';
import { SETUP_OPTION_PROF } from '../../Web/DeviceSetup/constants';

export const loadScripts = () => {
  // after utag scripts and DL avail
  setTimeout(() => {
    if (window.vzwAnalytics && window.vzwAnalytics.events && window?.vzwDL?.page?.pageName) {
      window.vzwAnalytics.events.track('pageChangeEvent', { page: getUrlName(window?.vzdl?.page?.pageName), allowSamePage: true });
    }
  }, 500);

  setTimeout(() => {
    invokeOmniDLPageView();
    if (window?.vzdl?.page?.name === 'getStreamingDevices' && window.location.href.indexOf('addons') > -1) {
      if (getSession('isResumeOrder') === 'N' || getSession('isPlansEdit') !== 'Y' || getSession('addonBack') !== 'true') {
        const obj = window.vzdl && window.vzdl.txn && window.vzdl.txn.product && window.vzdl.txn.product.current;
        console.log(obj);
        const product =
          obj &&
          obj.length > 0 &&
          obj.map((item) => ({
            name: item.name,
            id: item.id,
            category: item.category,
            discount: item.discount,
            line: item.line,
            merchCat: item?.merchCat || null,
            offer: item.offer,
            qty: item.qty,
            sku: item.sku,
            shared: item.shared,
            nonRecurringPrice: item.nonRecurringPrice,
            recurringPrice: item.recurringPrice,
            action: item.action,
            path: item.path,
          }));
        const omniTaggingData = {
          product,
          openCart: true,
        };
        const paylod = {
          eventType: 'INFO',
          message: 'AVAILABLE-PROMOTIONS',
          note: omniTaggingData,
        };
        console.log(omniTaggingData);
        eventDispatcher('addToCart', omniTaggingData);
        logger(paylod);
      }
    }
    reInitChat();
    reInitCall();
  }, 500);
};

const invokeOmniDLPageView = () => {
  const pageName = getPageName();
  const userSetup = getCookie('selectedSetupOption');
  const queueData = getPageViewOverrides(pageName);
  const { data, data: { page: pageOveride } = {} } = queueData;
  if (userSetup && window.vztag && window.vztag.api && window.location.href.indexOf('cart') > -1) {
    window.vztag.api.dispatch('pageView', {});
    window.vztag.api.dispatch('openView', {
      name: userSetup,
    });
  } else if (window.vztag && window.vztag.api) {
    window.vztag.api.dispatch('pageView', { name: window?.vzdl?.page?.name || pageName, ...(pageOveride ? { data } : {}) });
    clearPageViewOverrides(pageName);
  }
  store.dispatch({ type: 'TAGGING_API_LOADED', response: true, pageName, success: true });
};

export const reInitChat = () => {
  try {
    if (window.reInitChatFrameworkNSA && typeof window.reInitChatFrameworkNSA !== 'undefined') {
      window.reInitChatFrameworkNSA();
    }
    if (window.EchannelVera.reInitChatFrameworkNsaDC && typeof window.EchannelVera.reInitChatFrameworkNsaDC !== 'undefined') {
      window.EchannelVera.reInitChatFrameworkNsaDC();
    }
  } catch (error) {
    console.log('Error: Chat Reinit Failed in Tagging.index.js', error);
  }
};

const reInitCall = () => {
  try {
    if (window.reInitC2c && typeof window.reInitC2c !== 'undefined') {
      window.reInitC2c();
    }
  } catch (error) {
    console.log('Error in components.common.Tagging.index.js', error);
  }
};

export const eventDispatcher = (eventName, dataObject) => {
  console.log('eventDispatcher', dataObject);
  let dataObjectVal;
  let dataObjectPlans;
  if (dataObject && dataObject.addAccessories && eventName === 'addToCart') {
    dataObjectVal = dataObject.addAccessories;
  } else if (dataObject && dataObject.current && dataObject.current.length > 0 && eventName === 'addToCart') {
    dataObjectPlans = dataObject;
  } else if (dataObject && dataObject.addYtTv) {
    dataObjectVal = dataObject.addYtTv;
  } else if (dataObject && dataObject.addVZProtect) {
    dataObjectVal = dataObject.addVZProtect;
  } else if (dataObject && dataObject.removeYtTv) {
    dataObjectVal = dataObject.removeYtTv;
  } else if (dataObject && dataObject.removeVZProtect) {
    dataObjectVal = dataObject.removeVZProtect;
  } else if (dataObject && dataObject.npanxx) {
    dataObjectVal = dataObject.npanxx;
  } else if (dataObject && dataObject.removeAccessories && eventName === 'removeFromCart') {
    dataObjectVal = dataObject.removeAccessories;
  } else if (dataObject && dataObject.addWHWPlan) {
    dataObjectVal = dataObject.addWHWPlan;
  }
  if (dataObject && dataObject.product && dataObject.product.length > 0 && eventName === 'addToCart') {
    dataObjectVal = dataObject;
  }

  let omniTaggingData = {};
  if (dataObjectPlans && dataObjectPlans.current && eventName === 'addToCart') {
    omniTaggingData = {
      openCart: false,
      product: dataObjectPlans.current,
    };
  }
  const isPlansOverviewwPage = window.location.href.includes('/plansOverview.html');
  if (dataObjectVal && eventName === 'addToCart' && dataObjectVal?.prevPageName === 'plansOverview') {
    omniTaggingData = { product: dataObjectVal.product, prevPageName: 'plansOverview' };
  }
  if (dataObjectVal && eventName === 'addToCart' && dataObjectVal?.prevPageName === 'plansOverview' && dataObjectVal?.openCart === true) {
    omniTaggingData = { product: dataObjectVal.product, prevPageName: 'plansOverview', openCart: true };
  }
  if (
    dataObjectVal &&
    (eventName === 'addToCart' || eventName === 'removeFromCart') &&
    !isPlansOverviewwPage &&
    dataObjectVal?.prevPageName !== 'plansOverview'
  ) {
    const prodIdTagging = dataObjectVal?.whwProdId ? dataObjectVal?.whwProdId : '';
    omniTaggingData = {
      cartId: null,
      openCart: false,
      product: [
        {
          name: dataObjectVal.name ? dataObjectVal.name : '',
          id: dataObjectVal.prodId ? dataObjectVal.prodId : prodIdTagging,
          category: 'accessories',
          discount: null,
          line: null,
          merchCat: 'accessories',
          offer: null,
          qty: dataObjectVal?.whwQty ? dataObjectVal?.whwQty : '1',
          sku: null,
          shared: 'N',
          nonRecurringPrice: null, // amount
          tradein: null,
          recurringPrice: 0,
          ...getPlanSelectionJourney(),
        },
      ],
    };
  }
  if (dataObjectVal && eventName === 'addToCart') {
    if (dataObjectVal?.openCart === true && window.location.href.indexOf('addons') > -1) {
      omniTaggingData = { product: dataObjectVal.product, openCart: true };
    }
    if (dataObjectVal?.page === 'progressivePlans') {
      omniTaggingData = {
        product: dataObjectVal.product.map((prod) => ({ ...prod, ...(!prod?.action && { ...getPlanSelectionJourney() }) })),
        openCart: dataObjectVal?.openCart,
      };
    }
    if (dataObjectVal?.page === 'popularPlan') {
      omniTaggingData = { product: [...dataObjectVal.product], openCart: dataObjectVal?.openCart };
    }
  }

  // All events must be entered below
  if (window.vztag && window.vztag.api) {
    switch (eventName) {
      case 'linkClick':
        window.vztag.api.dispatch(eventName, dataObject);
        break;
      case 'openView': // event to capture the opening of a modal
        window.vztag.api.dispatch(eventName, dataObject);
        break;
      case 'closeView': // event to capture the closure of a modal
        window.vztag.api.dispatch(eventName, dataObject);
        break;
      case 'addToCart':
        window.vztag.api.dispatch('addToCart', omniTaggingData);
        break;
      case 'removeFromCart':
        window.vztag.api.dispatch('removeFromCart', omniTaggingData);
        break;
      case 'notify':
        window.vztag.api.dispatch('notify', dataObject);
        break;
      case 'sendData': // event to capture the closure of a modal
        window.vztag.api.dispatch('sendData', dataObject);
        break;
      case 'openView_v2':
        triggerOpenView(dataObject);
        break;
      case 'error':
        window.vztag.api.dispatch('error', {
          message: (dataObject && dataObject?.message) ?? '',
          id: (dataObject && dataObject?.id) ?? '',
        });
        break;
      default:
    }
  }
};

const updateValue = (value, suffix) => (value ? `${value}|${suffix}` : suffix);
const updatePageThrottle = (page, value) => {
  page.throttle = updateValue(page.throttle, value);
};

const updateEventValue = (value, suffix) => (value ? `${value},${suffix}` : suffix);

const handleJointTransactionFlow = (page) => {
  page.subFlow = sessionStorage.getItem('checkingAbandonCartForTagging') === 'true' ? updateValue(page.subFlow, 'res_mhjt') : page.subFlow;
  page.subFlow = updateValue(page.subFlow, 'mhjt');
  updatePageThrottle(page, 'mhjt y');
  if(enableNgdJTCartFFlag()) {
    const cdlThrottleList = getCookie('cdlThrottleList') || '';
    const isNGDJTComboControl = cdlThrottleList.includes('ngdJTCombo_C_Enabled');
    if(isJTFlowFromNGDCart()) {
      updatePageThrottle(page, 'ngd_jt_t');
    } else if(isNGDJTComboControl){
      updatePageThrottle(page, 'ngd_jt_c');
    }
  }
};

const handleECJointTransactionFlow = (page) => {
  page.subFlow = updateValue(page.subFlow, 'mhjt-ec');
  page.subFlow = sessionStorage.getItem('checkingAbandonCartForTagging') === 'true' ? updateValue(page.subFlow, 'res_mhjt') : page.subFlow;
    updatePageThrottle(page, 'mhjt y');
};

const setJTPageFlowAndThrottle = (page) => {
  if (isECJointTransactionFlow()) {
    handleECJointTransactionFlow(page);
  } else if (isJointTransactionFlow()) {
    handleJointTransactionFlow(page);
  }
};
export const setSmlpLQResTags = (page) => {
  if (`${page?.subFlow}`.includes('sot_')) return;
  const emailTag = getSession('emailSmlpLQRes') === 'Y';
  const popupTag = getSession('popupSmlpLQRes') === 'Y';
  if (emailTag) {
    page.subFlow = updateValue(page.subFlow, 'sot_e');
  }
  if (popupTag) {
    page.subFlow = updateValue(page.subFlow, 'sot_r');
  }
};
export const setGeoQualTags = (page) => {
  if (`${page?.subFlow}`.includes('plqs-geo')) return;
  const lqResponse = getSession('LQResponse');
  if (!lqResponse) return;
  const { output = {} } = JSON.parse(lqResponse);
  if (output?.bulkQualAddressType === 'GEO_LOCATION') {
    page.subFlow = updateValue(page.subFlow, 'plqs-geo');
  }
};
export const setPromptGeoQualTags = (page) => {
  if (`${page?.subFlow}`.includes('prompt geo')) return;
  const autoLocationPromptGeo = getSession('autoLocationPromptGeo') || '';
  if (autoLocationPromptGeo) {
    page.subFlow = updateValue(page.subFlow, 'prompt geo');
  }
};
/**
 * Sets the subFlow value based on various flow conditions
 * Note: Multiple conditions can match - later matches override earlier ones
 */
export const whwFlag = (page) => {
  const tduFlow = getSession('tdu_flow', 'true');
  const ateFlow = getSession('ate_flow', 'true');
  const isCbandStalledOnProgressivePlans = isCbandStalledFlow() && page.name === "progressiveplans";
  
  // Check each flow condition and set subFlow accordingly
  // Later conditions override earlier ones if multiple conditions are true
  const onDeviceUpgradePage = isDeviceUpgradeFlow() || getSession('isDUSession') === 'true';
  if (onDeviceUpgradePage) {
    page.subFlow = (isTRUPFlow() || isTrupUpgradeFlow()) ? 'trup' : 'rup';
  } else if (isTRUPFlow() || isTrupUpgradeFlow()) {
    page.subFlow = updateValue(page.subFlow, 'trup');
  }
  if (isWWM()) page.subFlow = 'wwm';
  if (tduFlow) page.subFlow = 'tdu';
  if (isCbandStalledOnProgressivePlans) page.subFlow = 'stall_ofs';
  if (ateFlow) page.subFlow = 'ate&tdu';
  if (isTRUPFlow() || isTrupUpgradeFlow()) page.subFlow = 'trup';
};

export const getResumeSubFlow = (page) =>{
    if(getSession('isResumeOrder') === 'Y'){
      page.subFlow = updateValue(page.subFlow, 'res_e_ec');
    }
}

const getExpressCartSandboxValue = (sandBoxValue, pagename) => {
  if (pagename === 'expresscart') {
    const fwaPastDueEnabled = getCookie('fwaPastDueEnabled') === 'Y';
    const { search } = window.location;
    const params = new URLSearchParams(search);
    if (params.get('ACCFail') === 'Y') {
      sandBoxValue = fwaPastDueEnabled ? `pdb_y` : `pdb_n`;
    }
  }
  return sandBoxValue;
};

export const getMiniCartFooterTaggingValues = (pagename, callName) => {
  const isPageApplicable = constants.AAL_PAGES_MINI_CART.includes(pagename);
  
  if (!isPageApplicable) {
    return { sandboxPart: null, throttlePart: null };
  }

  const cradleData = getCookie('cdlThrottleList') || '';
  
  if (cradleData?.includes(constants.MINICART_SANDBOX_T_PLANS)) {
    return { 
      sandboxPart: callName === constants.TAGGING_CALL_TYPES.LINK ? constants.MINICART_SANDBOX_T_PLANS : null, 
      throttlePart: constants.MINICART_THROTTLE_T,
    };
  }
  
  if (cradleData?.includes(constants.MINICART_SANDBOX_C_PLANS)) {
    return { 
      sandboxPart: callName === constants.TAGGING_CALL_TYPES.LINK ? constants.MINICART_SANDBOX_C_PLANS : null, 
      throttlePart: constants.MINICART_THROTTLE_C,
    };
  }

  return { sandboxPart: null, throttlePart: null };
};

export const getMiniCartFooterSandBoxValue = (sandBoxValue, pagename, callName = constants.TAGGING_CALL_TYPES.PAGE_VIEW) => {
  const { sandboxPart } = getMiniCartFooterTaggingValues(pagename, callName);
  
  if (sandboxPart) {
    sandBoxValue = sandBoxValue ? `${sandBoxValue}|${sandboxPart}` : sandboxPart;
  }
  
  return sandBoxValue;
}

const updatePageThrottleForMiniCartFooter = (page, pagename) => {
  const { throttlePart } = getMiniCartFooterTaggingValues(pagename, constants.TAGGING_CALL_TYPES.PAGE_VIEW);
  if (throttlePart) {
    page.throttle = updateValue(page.throttle, throttlePart);
  }
};
export const getContactInfoModalThrottleValue = (pagename) => {
  const isPageApplicable = pagename === 'contactinfo';
  
  if (!isPageApplicable) {
    return { throttlePart: null };
  }

  const cradleData = getCookie('cdlThrottleList') || '';
  
  if (cradleData?.includes(constants.CONTACTINFO_MODAL_T)) {
    return { throttlePart: constants.CONTACTINFO_THROTTLE_T };
  }
  
  if (cradleData?.includes(constants.CONTACTINFO_MODAL_C)) {
    return { throttlePart: constants.CONTACTINFO_THROTTLE_C };
  }

  return { throttlePart: null };
};

const updatePageThrottleForContactInfoModal = (page, pagename) => {
  const { throttlePart } = getContactInfoModalThrottleValue(pagename);
  if (throttlePart) {
    page.throttle = updateValue(page.throttle, throttlePart);
  }
};

const getSandboxValue = (sandBoxValue, pagename) => {
  if (sandBoxValue) {
    return sandBoxValue;
  }

  const prospectExpressPages = ['progressiveplan', 'cart', 'addons', 'orderreview', 'setup', 'expresstos', 'contactinfo', 'payment', 'confirmation', 'creditcheck', 'shipping', 'appointment','registration'];
  if (prospectExpressPages.includes(pagename)) {
    sandBoxValue = getProspectECSandboxvalue();
  }
  if (pagename === 'shipping') {
    sandBoxValue = isShippingTabEnabled() ? `${sandBoxValue}|FWA_Express_T_Pickup` : `${sandBoxValue}|FWA_Express_C_Pickup`;
  }
  if (pagename === 'progressiveplan' && showContinueCTAInFooter()) {
    sandBoxValue = `${sandBoxValue}|FWA_Continue_CTA_Footer_T_Install`;
  }
  
  sandBoxValue = getMiniCartFooterSandBoxValue(sandBoxValue, pagename);

  if(pagename === 'cart'){
        const emailFlow = getSession('emailFlow');
        if(emailFlow === 'Y'){
          updateEventInfo('event86');
        }
  }
  sandBoxValue = getExpressCartSandboxValue(sandBoxValue, pagename);
  
  return sandBoxValue;
};

export const checkDataTrackOfSelOptionTagging = (
  option,
  optionDetails,
  flow,
) => {
  const techRecommendationResult = getTechRecommendationLQResponse();
  const recommenderFlagCritical = techRecommendationResult && techRecommendationResult?.criticalLQResponse || false;
  const recommenderFlagHigh = techRecommendationResult && techRecommendationResult?.highLQResponse || false;
  let name = '';

  if (flow === "ecp" && optionDetails?.setupDesc && option?.setupName && optionDetails?.setupCharges) {
    const cleanedSetupDesc = optionDetails?.setupDesc?.replace(/<[^>]*>?/gm, '');
    name = `${option?.setupName} ${optionDetails?.setupCharges} ${cleanedSetupDesc}`;
  } else if (option?.type === SETUP_OPTION_PROF && option?.setupName && optionDetails?.setupCharges) {
    name = `${option?.setupName} ${optionDetails?.setupCharges}`;
  } else {
    name = optionDetails?.ariaLabelValue?.replace(/<[^>]*>?/gm, '')?.trim();
  }

  const finalName = name.trim();

  const setSandBoxValue = () => {
    if(recommenderFlagCritical){
      return constants.PRO_MAN_T;
    } 
    if(recommenderFlagHigh){
      return constants.PRO_REC_T;
    } 
    return undefined;
  }

  const dataTrackObject = {
    type: 'link',
    name: finalName,
     data: {
      target: {
        sandBox: setSandBoxValue(),
      },
    }, 
  };

  return JSON.stringify(dataTrackObject);
};

const setTechRecommenderSandBoxValue = (sandBoxValue) => {
  const techRecommendationResult = getTechRecommendationLQResponse();
  const recommenderFlagCritical = techRecommendationResult && techRecommendationResult?.criticalLQResponse || false;
  const recommenderFlagHigh = techRecommendationResult && techRecommendationResult?.highLQResponse || false;
  let techRecSandboxValue = sandBoxValue || '';
  if (recommenderFlagCritical) {
    techRecSandboxValue = `${techRecSandboxValue}|${constants.PRO_MAN_T}`;
  } else if (recommenderFlagHigh) {
    techRecSandboxValue = `${techRecSandboxValue}|${constants.PRO_REC_T}`;
  } else {
    techRecSandboxValue = `${techRecSandboxValue}|${constants.PRO_C}`;
  }
  return techRecSandboxValue;
}


export const getProspectECSandboxvalue = () => {
  let sandBoxValue;
  if (!isExpressCheckout()) {
    sandBoxValue = `fwaProspectExpressCheckout_c`;
    
  } else if (isExpressCheckoutNSE()) {
    sandBoxValue = `fwaProspectExpressCheckout_t`;
  }
  sandBoxValue = setTechRecommenderSandBoxValue(sandBoxValue);
  return sandBoxValue;
};

const setExpressCheckoutSandbox = (page) => {
  let sandBoxValue;
  if (isExpressCheckoutNSE()) {
      sandBoxValue = 'fwaProspectExpressCheckout_t';
      const emailFlow = getSession('emailFlow');
      if(emailFlow === 'Y'){
        updateEventInfo('event86');
      }
  }
  if (isExpressCheckout()) {
    sandBoxValue = 'FWA_Express_T_Checkout';
    sandBoxValue = getMiniCartFooterSandBoxValue(sandBoxValue, 'expresscheckout');
    getResumeSubFlow(page);
  }
  sandBoxValue = setTechRecommenderSandBoxValue(sandBoxValue);
  if (isProductsReady() && window.vzdl?.event) {
    const setupOptionSelected = getCookie('selectedSetupOption');
    window.vzdl.event.value =
      setupOptionSelected === 'PROFESSIONAL'
        ? updateEventValue(window.vzdl.event.value, 'event338')
        : updateEventValue(window.vzdl.event.value, 'event337');

    window.vzdl.event.productArrayView = updateValue(window.vzdl.event.productArrayView, true);
  }
  return sandBoxValue;
};

const setResumeCartSubFlow = (page) => {
  if(getSession('isResumeOrder') === 'Y'){
    if(isExpressCheckoutNSE()){
        page.subFlow = updateValue(page.subFlow, 'res_p_ec');
    }else{
      page.subFlow = updateValue(page.subFlow, 'res_p_or');
    }
  }
}

const updateStreamLineTagging = (pagename, page, utils) =>{
  if (pagename === 'streamlineordering') {
      utils.aiScoreTime = null;
      page.name = 'Progressiveplans Streamlineordering';
    }
  if (pagename !== 'progressiveplan') {
      page.throttle = updateValue(page.throttle, getSoThrottleValue());
  }
}

const getAiScoreOnConfirmationPage = (pagename, ABANDON_CART_INFO, utils) => {
  const { IdleTimeValue = 0, predictScore = 0 } = ABANDON_CART_INFO;
  if (pagename === 'confirmation' && IdleTimeValue && predictScore) {
    utils.aiScoreTime = `${predictScore}|${IdleTimeValue}`;
  }
};

const getDiscountIdTaggingOnConfirmationPage = (pagename, data) => {
  if (pagename === 'confirmation' && !isStreamlineFlow() && isEnableMiniCartTaggingFFlag()) {
    // eVar37
    window.vzdl.txn.discountId = window?.vzdl?.txn?.discountId ? `${window?.vzdl?.txn?.discountId}|${data?.[0]?.promoId}` : `${data?.[0]?.promoId}`;
  }
};

const getDiscountIdTaggingOnPage = (pagename, MHDiscountExist, data) => {
  if (pagename !== 'progressiveplan' && !isStreamlineFlow() && isEnableMiniCartTaggingFFlag() && MHDiscountExist && data.length) {
    // evar24
    window.vzdl.target.engagement.offered = window?.vzdl?.target?.engagement?.offered ? `${window?.vzdl?.target?.engagement?.offered}|${data?.[0]?.promoId}` : `${data?.[0]?.promoId}`;

    // eVar28
    window.vzdl.target.offer = window?.vzdl?.target?.offer ? `${window?.vzdl?.target?.offer}|${data?.[0]?.promoId}` : `${data?.[0]?.promoId}`;

  }
};

const getDiscountIDTagging = (pagename) => {
  if(isEnableMiniCartTaggingFFlag()) {
    const storeDetails = store.getState();
    const progressivePlansData = storeDetails?.progressivePlans?.progressivePlanAPiResponse?.data;
    const availablePromotions = progressivePlansData?.availablePromotions || [];
    const MHDiscountExist = availablePromotions?.includes('MHDiscount');
    const data = progressivePlansData?.lineLevelPlans?.lines?.[0]?.products?.[0]?.plans?.[0]?.price?.promos?.filter((promo) => promo?.promoDescription === 'MOBILE + HOME DISCOUNT $15') || [];

    getDiscountIdTaggingOnPage(pagename, MHDiscountExist, data);
    getDiscountIdTaggingOnConfirmationPage(pagename, data);
  }
};

const getOfferForAddonsPage = (pagename, offerId) => {
  if (!isLTE && !isStreamlineFlow() && pagename === 'addons' && offerId && getAdditionalDiscountTaggingFFlag()) {
    window.vzdl.target.offer = window.vzdl.target.offer ? `${window.vzdl.target.offer}|${offerId}` : `${offerId}`;
  }
}

const getOfferEdForProgressivePlan = (offerId)=>{
  if (!isLTE && !isStreamlineFlow() &&  offerId && getAdditionalDiscountTaggingFFlag()) {
    window.vzdl.target.engagement.offered = window.vzdl.target.engagement.offered ? `${window.vzdl.target.engagement.offered}|${offerId}` : `${offerId}`;
  }
}

const getDiscountIdForConfirmationPage = (pagename, offerId)=>{
  if (!isLTE && !isStreamlineFlow() &&  pagename === 'confirmation' && offerId && getAdditionalDiscountTaggingFFlag()) {
    window.vzdl.txn.discountId = window.vzdl.txn.discountId ? `${window.vzdl.txn.discountId}|${offerId}` : `${offerId}`;
  }

}

const getAiScoreTriggeredOnConfirmationPage = (pagename, ABANDON_CART_DISCOUNT_INFO, ABANDON_CART_INFO, utils) => {
  if(saveTheSaleTaggingFFlag()) {
    getAiScoreOnConfirmationPage(pagename, ABANDON_CART_DISCOUNT_INFO, utils);
  } else {
    getAiScoreOnConfirmationPage(pagename, ABANDON_CART_INFO, utils);
  }
};

const getAbandonCartDiscountInfoValue = () => getSession('ABANDON_CART_DISCOUNT_INFO') ? JSON.parse(getSession('ABANDON_CART_DISCOUNT_INFO')) : {};

const getPastDueEventTagging = () => {
  const pastDueBalanceAmount = getSession('pastDueBalAmount');
  if (pastDueBalanceAmount) {
    window.vzdl.event.pastDueBalance = pastDueBalanceAmount;
  }
};

// Helper: Handle movers flow confirmation page
const handleMoversConfirmation = (vzdl, pagename) => {
  if (isMoversFlow() && pagename === 'confirmation') {
    const oldPlanName = getSession('oldPlanName');
    const newPlanName = getSession('newPlanName');
    vzdl.txn = {
      ...vzdl.txn,
      planChanges: oldPlanName ? `${oldPlanName} | ${newPlanName}` : `${newPlanName} | ${newPlanName}`,
    };
  }
};

// Helper: Handle express checkout park settings
const handleExpressCheckoutPark = (vzdl) => {
  if (isExpressCheckout() && !isDesktopResolution()) {
    vzdl.park = {
      chatbuttonBottomGap: '40px',
    };
  }
};

// Helper: Handle contact info page
const handleContactInfoPage = (page, pagename, cradleThrottleList) => {
  if (pagename === 'contactinfo') {
    page.name = 'getcontactinfo';
    if (cradleThrottleList?.includes('FWA_C_SL_AC')) {
      page.subFlow = updateValue(page.subFlow, 'shell account fwa');
      page.throttle = updateValue(page.throttle, 'shell acc fwa');
    }
  }
};

const handleCreateProfilePage = (page, pagename) => {
  if (pagename === 'createprofile') {
    page.name = 'createprofile';
  }
};

// Helper: Parse offer ID from session
const parseOfferIdFromSession = () => {
  let parsedOffer = null;
  const offerIdFromSession = getSession('salesLandingOffers');
  try {
    if (offerIdFromSession) {
      parsedOffer = JSON.parse(offerIdFromSession);
    }
  } catch (e) {
    logError('Failed to parse salesLandingOffers from session storage', { error: e?.message });
  }
  return parsedOffer?.sedOfferId;
};

// Helper: Handle cart page
const handleCartPage = (page, pagename) => {
  if (pagename === 'cart') {
    setResumeCartSubFlow(page);
  }
};

// Helper: Handle express checkout page
const handleExpressCheckoutPage = (pagename) => {
  if (pagename === 'expresscheckout') {
    return setExpressCheckoutSandbox(window.vzdl.page);
  }
  return undefined;
};

// Helper: Handle progressive plan page
const handleProgressivePlanPage = (page, pagename, utils, offerId) => {
  if (pagename === 'progressiveplan') {
    utils.aiScoreTime = null;
    getOfferEdForProgressivePlan(offerId);
    if (showContinueCTAInFooter()) {
      page.throttle = updateValue(page.throttle, getSoThrottleValue('co y'));
    } else {
      page.throttle = updateValue(page.throttle, getSoThrottleValue('co n'));
    }
  }
};

// Helper: Handle express TOS page
const handleExpressTosPage = (page, pagename) => {
  if (pagename === 'expresstos') {
    page.name = 'Terms and Agreements';
  }
};

// Helper: Handle shipping page
const handleShippingPage = (page, pagename) => {
  if (pagename === 'shipping') {
    const shippingCraldeList = store.getState()?.SessionValues?.shippingCradleValue;
    const shippingThrottleKeys = getThrottleKeys(shippingCraldeList, 'FWA_Shipping');
    page.throttle = updateValue(page.throttle, shippingThrottleKeys && shippingThrottleKeys.join('|'));
  }
};

// Helper: Handle sandbox and cradle values
const handleSandboxAndCradleValues = (sandBoxValue, pagename, isOfferAppliedOnPlanPage) => {
  const finalSandboxValue = getSandboxValue(sandBoxValue, pagename);
  let newCradleData = getCookie('cdlThrottleList') || '';
  newCradleData = newCradleData?.split('|~')?.[0] || newCradleData;
  
  if (finalSandboxValue && !newCradleData?.includes(finalSandboxValue)) {
    newCradleData = updateValue(newCradleData, finalSandboxValue);
  }
  
  if (isOfferAppliedOnPlanPage === 'Y') {
    constants.SWEETNER_CONTROL_TREAT_GROUP.forEach((val) => {
      newCradleData = newCradleData?.replace(val, '');
    });
  }
  
  window.vzdl.target.sandbox = newCradleData;
};

// Helper: Handle overrides and script loading
const handleOverridesAndScriptLoading = (overrides) => {
  if (overrides && overrides[ADOBE_OVERRIDES.SKIP_PAGEVIEW]) {
    const taggingState = store.getState()?.tagging;
    if (taggingState?.eventQueue?.length) {
      taggingState.eventQueue.filter(Boolean).forEach(({ event, data }) => {
        try {
          eventDispatcher(event, data);
        } catch (adobeError) {
          // logError
        }
      });
      store.dispatch({ type: CLEAR_ADOBE_QUEUE });
    }
  } else {
    loadScripts();
  }
};

// Helper: Initialize common page tags
const initializeCommonPageTags = (page) => {
  setJTPageFlowAndThrottle(page);
  setSmlpLQResTags(page);
  setGeoQualTags(page);
  setPromptGeoQualTags(page);
  whwFlag(page);
};

export const setTagging = (pagename, response, overrides) => {
  const vzdl = { ...response };
  const isOfferAppliedOnPlanPage = getSession('planPageUpgradeOfferClicked');
  
  handleMoversConfirmation(vzdl, pagename);
  handleExpressCheckoutPark(vzdl);
  
  window.vzdl = vzdl;

   if (getCookie('role') === 'guest') {
    window.vzdl.user = window?.vzdl?.user || {};
    window.vzdl.user.customerRole = 'guest';
  }
  
  if (window.vzdl) {
    const { page } = window.vzdl;
    const { utils = {} } = vzdl;
    const cradleThrottleList = store.getState()?.contactInfo?.cradleThrottleList;
    const ABANDON_CART_INFO = getSession('ABANDON_CART_INFO') ? JSON.parse(getSession('ABANDON_CART_INFO')) : {};
    const ABANDON_CART_DISCOUNT_INFO = getAbandonCartDiscountInfoValue();
    
    initializeCommonPageTags(page);
    if (isTRUPFlow()) page.flow = 'eup';
    handleContactInfoPage(page, pagename, cradleThrottleList);
    handleCreateProfilePage(page, pagename);
    getAiScoreTriggeredOnConfirmationPage(pagename, ABANDON_CART_DISCOUNT_INFO, ABANDON_CART_INFO, utils);
    
    const offerId = parseOfferIdFromSession();
    
    handleCartPage(page, pagename);
    const sandBoxValue = handleExpressCheckoutPage(pagename);
    handleProgressivePlanPage(page, pagename, utils, offerId);
    updatePageThrottleForContactInfoModal(page, pagename);
    updatePageThrottleForMiniCartFooter(page, pagename);
    getOfferForAddonsPage(pagename, offerId);
    getDiscountIDTagging(pagename);
    handleExpressTosPage(page, pagename);
    getDiscountIdForConfirmationPage(pagename, offerId);
    updateStreamLineTagging(pagename, page, utils);
    handleShippingPage(page, pagename);
    getPastDueEventTagging();
    
    handleSandboxAndCradleValues(sandBoxValue, pagename, isOfferAppliedOnPlanPage);
    handleOverridesAndScriptLoading(overrides);
  } else {
    console.log('window.vzdl: false');
  }
};

// export const updatePageDetail = (updateObj) => {
//   if (window.vzdl && window.vzdl.page && updateObj === true) {
//     window.vzdl.page.detail = '';
//   }
// };

export const updatePageDetail = (value = '') => {
  if (window.vzdl && window.vzdl.page) {
    window.vzdl.page.detail = value;
  }
};

export const updateUrl = () => {
  if (window.vzdl && window.vzdl.page) {
    window.vzdl.page.url = window.location.href;
    // window.vzdl.page.url = window.location.pathname + window.location.hash;
  }
};

export const updateIntent = () => {
  if (window.vzdl && window.vzdl.page) {
    window.vzdl.target.engagement.intent = 'learn';
    // window.vzdl.txn = { engagement: { intent: 'learn' } };
  }
};

export const updateEventInfo = (value = '') => {
  if (window.vzdl && window.vzdl.event) {
    window.vzdl.event = { value };
  }
};
export const updateSandboxValue = (value) => {
  window.vzdl.target = window?.vzdl?.target || {};
  window.vzdl.target.sandbox = window?.vzdl?.target?.sandbox || '';
  if (!window?.vzdl?.target?.sandbox.includes?.(value)) {
    window.vzdl.target.sandbox = `${window.vzdl.target.sandbox}|${value}`;
  }
};

/* ACT44-318 - changes to update the email, mtn, locus id to AEP */
export const updateToAEP = (emailId, mdn = '') => {
  try {
    const lqResponse = sessionStorage.getItem(constants.LQ_RESPONSE);
    const locusID = lqResponse ? JSON.parse(lqResponse)?.output?.subLocationId : '';
    if (window?.vztag?.api?.dispatch) {
      window.vztag.api.dispatch(constants.METHOD_NAME, {
        data: {
          page: {
            detail: constants.ABT_YOURSELF,
          },
          utils: {
            rtm: {
              prospectEmail: emailId,
              mtn: mdn,
              locusId: locusID,
            },
          },
        },
      });
    }
  } catch (error) {
    logger('Error in processing data for updateToAEP');
  }
};

export const updateCSTaggingPageDetail = (detailMsg) => {
  eventDispatcher('sendData', {
    name: '',
    svars: {
      evar22: detailMsg,
    },
  });
};

export const modalOpenPageView = (detailMsg) => {
  window.coreData = window.coreData || [];
  window.coreData.push({
    task: 'emit',
    event: 'pageView',
    params: {
      detail: detailMsg,
    },
  });
};

export const triggerOpenView = (data) => {
  try {
    window.coreData = window.coreData || [];
    window.coreData.push({
      task: 'emit',
      event: 'openView',
      params: data,
    });
  } catch (taggingScriptError) {
    // Logger TBA
  }
};

export const setPageViewOverrides = (pageName, data) => {
  const adobeEventQueue = JSON.stringify({ ...getPageViewOverrides(pageName), ...{ [pageName]: data } });
  setSession('pageViewOverrides', adobeEventQueue);
};

export const getPageViewOverrides = (pageName) => JSON.parse(getSession('pageViewOverrides') || '{}')?.[pageName] || {};

export const clearPageViewOverrides = (pageName) => removeSessionItem(pageName);

export const isProductsReady = () => window.vzdl?.txn?.product;

export const prepareProductList = (products) => (products || []).filter(Boolean).map((productData) => ({
    name : productData.productDisplayName ?? '',
    id: productData.deviceId ?? '',
    category: "",
    discount: "",
    line: "",
    merchCat: "product",
    offer: "",
    qty: productData.qty ?? "1",
    sku: productData.skuId ?? '',
    shared: "N",
    nonRecurringPrice: productData.chargeBackAmount ?? '' ,
    recurringPrice: "",
}));

const getAdobeCoreData = () => {
  window.coreData = window.coreData || [];
  return window.coreData;
}
export const invokeReturnEvent = (data) => {
  if (!data?.products?.length) {
    return;
  }
  try {
    const productList = prepareProductList(data.products);
    const adobeCoreData = getAdobeCoreData();
    adobeCoreData.push({
      task: "emit",
      event: "txnReturn",
      params: {
        product: productList,
      },
    });
  } catch (error) {
    logError('invokeReturnEvent', error, FE_JS_ERROR);
  }
};
